<template>
  <div>
    <div class="fight-add">
      <div class="slide">
        <mySlide />
      </div>
      <div class="w1500">
        <div class="back-box-w  flex flex-ac flex-jsb">
          <div class="back-box flex flex-ac" @click="goPage">
            <i class="iconfont icon-back" />
            <span>返回</span>
          </div>
        </div>
        <div class="sty-warp">
          <div class="sty-one flex flex-ac">
            <div class="sty-one-hint">设置房间模式</div>
            <div class="sty-one-pattern">
              <div class="scRadio">
                <div class="scRadio-item" :class="{'scRadio-item-a':mode==2}" @click="mode=2">双人</div>
                <div class="scRadio-item" :class="{'scRadio-item-a':mode==3}" @click="mode=3">三人</div>
                <!-- <div class="scRadio-item" :class="{'scRadio-item-a':mode==4}" @click="mode=4">四人</div> -->
              </div>
            </div>
          </div>
          <div class="csgo-box1">
            <ul class="flex flex-w flex-jc">
              <li v-for="(item,index) in selectList" :key="item.id" class="box-hover">
                <div class="li-div">
                  <div class="bei1">
                    <img :src="item.img_main" class="img_main" />
                    <img :src="item.img_active" class="img_active" />
                  </div>
                  <div class="name">{{ item.name }}</div>
                  <div class="money-warp flex flex-jc flex-ac">
                    <img src="@/assets/images/money.png" class="money-img" />
                    <span>{{ item.price }}</span>
                  </div>
                  <div class="add-num flex flex-ac flex-jsb" style="margin: 0 auto;">
                    <img src="@/assets/images/jian.png" alt="" srcset="" @click="add(item,-1,index)">
                    <div class="num">{{ item.num }}</div>
                    <img src="@/assets/images/add.png" alt="" srcset="" @click="add(item,1,index)">
                  </div>
                  <div class="li-div-detail">
                    <i class="el-icon-info" @click="getBoxInfo(item)" />
                  </div>
                </div>
              </li>
              <li class="box-hover">
                <div class="li-div flex flex-ac flex-jc" @click="open" style="height: 100%;padding-top: 15px;">
                  <div class="bei">
                    <div class="add-icon flex flex-ac flex-jc"><i class="el-icon-plus"></i></div>
                    <div class="name" style="margin-top: 10px;">添加箱子</div>
                  </div>
                  <div class="name"></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="btn-w-r-bg flex-0" @click="createRoom">
          <div class="btn-c-r flex flex-jc flex-ac">
            <span>创建对战</span>
            <img src="@/assets/images/money.png" class="money-img" />
            <span>{{ totalPrice.toFixed(2) }}</span>
          </div>
        </div>
      </div>
    </div>
    <myhomebot></myhomebot>
    <div class="commonBg"></div>
    <sel-box ref="sel-box" @onClose="onClose" />
  </div>
</template>

<script>
import myhomebot from "@/components/my_homebot.vue";
import mySlide from "@/g-components/my_slide.vue";
import SelBox from "@/views/fight/sel-box.vue";

export default {
  components: {
    myhomebot, mySlide, SelBox
  },
  data() {
    return {
      mode: 2,
      totalPrice: 0,
      num: 0, // [修复1] 添加缺失的 num 变量
      loading2: false, // [修复4] 添加缺失的 loading2 变量
      selectList: []
    };
  },
  created() { },
  beforeCreate() { },
  methods: {
    goPage() {
      this.$router.push('/fight');
    },
    open() {
      this.$refs['sel-box'].toggle(this.selectList, 'box')
    },
    getBoxInfo(item) {
      this.$refs['sel-box'].toggle(item, 'skin')
    },
    onClose(selectList) {
      this.selectList = selectList
      this.calculateTotal(); // [优化] 抽取公共计算逻辑
    },
    // [优化] 抽取计算总价和总数的方法，避免重复代码
    calculateTotal() {
      let totalP = 0;
      let totalN = 0;
      this.selectList.forEach(item => {
        // 确保 item.num 存在，默认为 0
        const count = item.num || 0;
        const price = item.price || 0;
        totalP += price * count;
        totalN += count;
      });
      this.totalPrice = totalP;
      this.num = totalN;
    },
    add(item, type, index) {
      if (type == 1) {
        // [修复1] 现在 this.num 已定义，判断生效
        if (this.num >= 6) {
          this.$message.error('最多只能选择6个商品')
          return false
        }
        item.num = (item.num || 0) + 1;
      } else {
        item.num = (item.num || 0) - 1;
        if (item.num <= 0) {
          this.selectList.splice(index, 1)
        }
      }
      // [优化] 调用统一计算方法，移除 $forceUpdate
      // 如果视图仍未更新，请检查 item 对象是否是响应式的。
      // 通常直接修改对象属性在 Vue2 中是响应式的，除非该属性最初不存在。
      this.calculateTotal();

      // 如果确实遇到视图不更新的问题，建议使用 $set 而不是 $forceUpdate
      // this.$set(item, 'num', item.num); 
    },
    //创建活动
    createRoom() {
      if (!this.$store.state.loginState) {
        this.$store.commit("getLogin", true);
        return;
      }
      let boxs = []
      this.selectList.forEach((e) => {
        boxs.push({
          num: e.num,
          id: e.id
        })
      });
      if (boxs.length == 0) {
        this.$message.warning('请选择箱子!')
        return;
      }
      this.loading2 = true;
      let param = {
        mode: this.mode,
        boxs,
      };
      this.$doPost("/api/hall.Battle/createRoom", param).then((res) => {
        this.$store.commit("getAboutMon", res.data)
        this.$router.push({
          path: '/fight/room?id=' + res.data.id
        })
      }).catch(() => {
        this.loading2 = false
      })
    },
  },
};
</script>

<style lang="less" scoped>
.fight-add {
  min-height: 100vh;
  .back-box {
    color: #fff;
    cursor: pointer;
    i {
      margin-right: 8px;
    }
  }
  .back-box-w {
    padding: 20px 0;
  }
  .sty-one-hint {
    color: #fff;
    margin-right: 10px;
  }
  .btn-w-r-bg {
    width: 300px;
    margin: 0 auto;
  }
}
</style>